import { render } from "./traselfstudy.vue?vue&type=template&id=4b9ab912"
import script from "./traselfstudy.vue?vue&type=script&lang=js"
export * from "./traselfstudy.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__